export const aggregatePiecesRows = (rows) => {
  const pieces = [];
  const pieceIds = new Set();
  rows.forEach(row => {
    if (pieceIds.has(row.id)) {
      const piece = pieces.find(p => p.id === row.id);
      piece.authors.push({
        full_name: row.full_name,
        slug: row.slug,
      });
      return;
    }
    const piece = {
      id: row.id,
      title: row.title,
      image_path: row.image_path,
      authors: [
        {
          full_name: row.full_name,
          slug: row.slug,
        }
      ],
      issue_id: row.id,
      issue_title: row.title,
    };
    pieces.push(piece);
    pieceIds.add(row.id);
  });
  return pieces;
};